//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      type: 'hex',
      hex: '#FF00FF',
      insCopy: false,
      scriptCopy: false,
      style: {
        app_radius: 10,
        app_bg_color: '#FFFFFF',
        text_color: '#000000',
        btn_radius: 20,
        btn_bg_color: '#6C2BC2',
        btn_text_color: '#FFFFFF'
      },
    }
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
  },
  computed: {
    collapsed() {
      return this.$store.state.prefs.collapseWidget
    },
    ins() {
      return `<ins class="artforge-widget" data-id="${this.project.slug}" data-container-radius="${this.style.app_radius}" data-app-bg-color="${(this.style.app_bg_color).replace('#', '')}" data-text-color="${this.style.text_color.replace('#', '')}" data-btn-radius="${this.style.btn_radius}" data-btn-bg-color="${this.style.btn_bg_color.replace('#', '')}" data-btn-text-color="${this.style.btn_text_color.replace('#', '')}"></ins>`
    },
    script() {
      return '<script src="http://localhost:3000/js/widget.js" async></s' + 'cript>';
    },
  },
  mounted() {
    this.style.app_radius = this.$store.state.prefs.widget_app_radius
    this.style.app_bg_color = this.$store.state.prefs.widget_app_bg_color
    this.style.text_color = this.$store.state.prefs.widget_text_color
    this.style.btn_radius = this.$store.state.prefs.widget_btn_radius
    this.style.btn_bg_color = this.$store.state.prefs.widget_btn_bg_color
    this.style.btn_text_color = this.$store.state.prefs.widget_btn_text_color
  },
  methods: {
    saveStyle(option) {
      this.$store.dispatch('setPref', {
        pref: `widget_${option}`,
        value: this.style[option],
      })
    },
    setCollapsed(collapsed) {
      this.$store.dispatch('setPref', {
        pref: `collapseWidget`,
        value: collapsed,
      })
    },
    copyIns() {
      navigator.clipboard.writeText(this.ins);
      this.insCopy = true
      setTimeout(() =>  {
        this.insCopy = false
      }, 3000)
    },
    copyScript() {
      navigator.clipboard.writeText(this.script);
      this.scriptCopy = true
      setTimeout(() =>  {
        this.scriptCopy = false
      }, 3000)
    }
  }
}
